export const API_URL = `${process.env.API}/internal/account`;
export const API_URL_SUFFIX = `/internal/account`;
export const API_INVENTORY_URL = `${process.env.API}/inventory`;
export const API_INVENTORY_SUFFIX = `/inventory`;
export const API_PERMITS_URL = `${process.env.API}/permits`;
export const JEST_DOMAIN = `${process.env.API}`;
export const TOKEN_LOCAL_STORAGE_KEY = 'internalaccount';
export const TOKEN_COOKIE_NAME = 'ia_token';
export const LOGIN_PATH = '/internal/account/login';
export const REPORT_DOWNLOAD_PATH = '/internal/reporting/scheduled/download';
export const EMPTY_TIME_STRING = '0001-01-01T00:00:00Z';
export const EXCLUDE_LOGIN_PATHS = [
  '/internal/account/recover-password',
  '/internal/account/reset-password',
  '/internal/account/confirm-email',
  '/internal/account/change-password',
];
export const DASHBOARD_PATH = '/internal/account/hub';

export const INFO_ALERT_LEVEL = 'INFO';
export const WARNING_ALERT_LEVEL = 'WARNING';
export const SUCCESS_ALERT_LEVEL = 'SUCCESS';
export const ERROR_ALERT_LEVEL = 'ERROR';

export const THROTTLE_AT_COUNT = 100;

export const PERSIST_KEY = 'internalaccount';

export const POC_PRIMARY = 'POC_PRIMARY';
export const POC_SECONDARY = 'POC_SECONDARY';
export const POC_ADDITIONAL = 'POC_ADDITIONAL';

export const LOCATION_NAME_FIELD_TYPE = 'location-name';
export const FIRST_NAME_FIELD_TYPE = 'first-name';
export const LAST_NAME_FIELD_TYPE = 'last-name';
export const EMAIL_FIELD_TYPE = 'email';
